import { v4 as uuid } from 'uuid';

export type PatientId = string & { readonly __brand: 'PatientId' };
export type StructureSetId = string & { readonly __brand: 'StructureSetId' };
export type RoiId = string & { readonly __brand: 'RoiId' };
export type RegistrationId = string & { readonly __brand: 'RegistrationId' };
export type DoseId = string & { readonly __brand: 'DoseId' };
export type PlanId = string & { readonly __brand: 'PlanId' };
export type ImageId = string & { readonly __brand: 'ImageId' };

export const newPatientId = (): PatientId => uuid() as PatientId;
export const newStructureSetId = (): StructureSetId => uuid() as StructureSetId;
export const newRoiId = (): RoiId => uuid() as RoiId;
export const newRegistrationId = (): RegistrationId => uuid() as RegistrationId;
export const newDoseId = (): DoseId => uuid() as DoseId;
export const newPlanId = (): PlanId => uuid() as PlanId;
export const newImageId = (): ImageId => uuid() as ImageId;

/**
 * Cast a known-valid GUID string to a branded ID.
 * Use only when the string is already known to be a valid GUID
 * (e.g., from connector hydration).
 */
export const asPatientId = (s: string): PatientId => s as PatientId;
export const asStructureSetId = (s: string): StructureSetId =>
    s as StructureSetId;
export const asRoiId = (s: string): RoiId => s as RoiId;
export const asRegistrationId = (s: string): RegistrationId =>
    s as RegistrationId;
export const asDoseId = (s: string): DoseId => s as DoseId;
export const asPlanId = (s: string): PlanId => s as PlanId;
export const asImageId = (s: string): ImageId => s as ImageId;
